jQuery(document).ready(function($) {
    const $blocks = $('.side-panel-block');
    
    $blocks.each(function() {
        const $panel = $(this).find('.hs-overlay');
        const panelId = $panel.attr('id');
        
        if (panelId) {
            // Find any triggers that open this panel
            const $triggers = $(`[data-hs-overlay="#${panelId}"]`);            
            $triggers.on('click', function(e) {
                e.preventDefault();
                $('html').css('overflowY', 'hidden');
            });
            
            // Listen for click on close button and overlay background to restore scroll
            $panel.find('button[data-hs-overlay]').on('click', function() {
                $('html').css('overflowY', 'auto');
            });
            
            // Handle clicks on the overlay background
            $(document).on('click', '[data-hs-overlay-backdrop-template]', function() {
                $('html').css('overflowY', 'auto');
            });
        }
    });
    
    // Handle Escape key press
    $(document).on('keyup', function(e) {
        if (e.key === 'Escape') {
            $('html').css('overflowY', 'auto');
        }
    });
});